// extracted by css-extract-rspack-plugin
export default {"cls1":"ProfilePdfPackCard-cls1_0MR","cls2":"ProfilePdfPackCard-cls2_5CJ ProfilePdfPackCard-cls1_0MR"};